import { urlConfig } from "../../config/urlConfig";
import { postCall } from "../httpService";

const RolesGet = urlConfig.RolesGet;
const ExcelGet = urlConfig.ExcelGet;
const GetPermissionData = urlConfig.GetPermissionData
const  GetAccountContext = urlConfig.GetAccountContext
const GetRoleDataEdit = urlConfig.GetRoleDataEdit
const RolesStatusChange= urlConfig.RolesStatusChange
const CreateRole = urlConfig.CreateRole
   

export const getRolesData = async (params: any) => {
  try {
    const response = await postCall(RolesGet, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const getPermissionsData = async (params: any) => {
  try {
    const response = await postCall(GetPermissionData, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const geAccountContext = async (params: any) => {
  try {
    const response = await postCall(GetAccountContext, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const getAllRolesDataEdit = async (params: any) => {
  try {
    const response = await postCall(GetRoleDataEdit, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const rolesStatusChange = async (params: any) => {
  try {
    const response = await postCall(RolesStatusChange, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const createRoles = async (params: any) => {
  try {
    const response = await postCall(CreateRole, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};